module.exports = __webpack_public_path__ + "img/child.6d3abffd.png";